import script from "./FileCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./FileCarousel.vue?vue&type=script&setup=true&lang=js"

import "./FileCarousel.vue?vue&type=style&index=0&id=244032e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244032e5"]])

export default __exports__